var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-container" }, [
    _c("div", { staticClass: "page-header" }, [
      _c(
        "div",
        { staticClass: "d-flex align-items-center w-100" },
        [
          _c(
            "b-button",
            {
              staticClass: "mr-3",
              attrs: { variant: "link" },
              on: {
                click: function($event) {
                  return _vm.onBack()
                }
              }
            },
            [
              _c("v-icon", {
                attrs: { name: "buttons/chevrons_left", size: 13 }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.isBusy
            ? _c(
                "h4",
                {
                  staticClass: "mr-auto",
                  attrs: { id: "location-ellipsis-loading" }
                },
                [_vm._v("Загрузка объекта")]
              )
            : _c("h4", { staticClass: "mr-auto" }, [_vm._v(_vm._s(_vm.title))]),
          _vm._v(" "),
          _vm.readOnlyButtonVisible
            ? _c(
                "span",
                {
                  class: [
                    "custom-tag cursor-pointer mr-2",
                    _vm.newItem.read_only ? "tag-danger" : "tag-success"
                  ],
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.readOnlyTapped()
                    }
                  }
                },
                [
                  _c("v-icon", {
                    staticClass: "mr-2",
                    attrs: {
                      name: _vm.newItem.read_only
                        ? "buttons/circle_cross"
                        : "buttons/circle_check",
                      size: 12
                    }
                  }),
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        this.newItem.read_only
                          ? "Редактирование запрещено"
                          : "Редактирование разрешено"
                      ) +
                      "\n      "
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-button",
            {
              staticClass: "custom-btn-primary",
              attrs: { disabled: _vm.isDisabled || _vm.loading },
              on: {
                click: function($event) {
                  return _vm.handleSubmit()
                }
              }
            },
            [
              _vm.loading
                ? _c("b-spinner", { attrs: { small: "" } })
                : _vm._e(),
              _vm._v(" "),
              _c("v-icon", { attrs: { name: "buttons/check", size: 13 } }),
              _vm._v("\n        Сохранить\n      ")
            ],
            1
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "page-body", staticStyle: { "overflow-y": "auto" } },
      [
        _c("b-skeleton-wrapper", {
          attrs: { loading: _vm.isBusy },
          scopedSlots: _vm._u([
            {
              key: "loading",
              fn: function() {
                return [
                  _c(
                    "b-tabs",
                    { staticClass: "custom-tabs", attrs: { card: "" } },
                    [
                      _c("b-tab", {
                        attrs: { disabled: "" },
                        scopedSlots: _vm._u([
                          {
                            key: "title",
                            fn: function() {
                              return [
                                _c("v-icon", {
                                  staticClass: "mr-2",
                                  attrs: { name: "navbar/locations", size: 13 }
                                }),
                                _vm._v(" "),
                                _c("span", [_vm._v("Основная")])
                              ]
                            },
                            proxy: true
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("b-tab", {
                        attrs: { disabled: "" },
                        scopedSlots: _vm._u([
                          {
                            key: "title",
                            fn: function() {
                              return [
                                _c("v-icon", {
                                  staticClass: "mr-2",
                                  attrs: { name: "buttons/page_list", size: 13 }
                                }),
                                _vm._v(" "),
                                _c("span", [_vm._v("Детали")])
                              ]
                            },
                            proxy: true
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("b-tab", {
                        attrs: { disabled: "" },
                        scopedSlots: _vm._u([
                          {
                            key: "title",
                            fn: function() {
                              return [
                                _c("v-icon", {
                                  staticClass: "mr-2",
                                  attrs: {
                                    name: "buttons/user_group_add",
                                    size: 13
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", [_vm._v("Вакансии")])
                              ]
                            },
                            proxy: true
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("b-tab", {
                        attrs: { disabled: "" },
                        scopedSlots: _vm._u([
                          {
                            key: "title",
                            fn: function() {
                              return [
                                _c("v-icon", {
                                  staticClass: "mr-2",
                                  attrs: {
                                    name: "navbar/recruit_tasks",
                                    size: 13
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", [_vm._v("Подбор")])
                              ]
                            },
                            proxy: true
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("b-tab", {
                        attrs: { disabled: "" },
                        scopedSlots: _vm._u([
                          {
                            key: "title",
                            fn: function() {
                              return [
                                _c("v-icon", {
                                  staticClass: "mr-2",
                                  attrs: {
                                    name: "buttons/card_container",
                                    size: 13
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", [_vm._v("Услуги исполнителей")])
                              ]
                            },
                            proxy: true
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("b-tab", {
                        attrs: { title: "Работы", disabled: "" },
                        scopedSlots: _vm._u([
                          {
                            key: "title",
                            fn: function() {
                              return [
                                _c("v-icon", {
                                  staticClass: "mr-2",
                                  attrs: { name: "buttons/work", size: 13 }
                                }),
                                _vm._v(" "),
                                _c("span", [_vm._v("Работы")])
                              ]
                            },
                            proxy: true
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _vm.canLocationReadFinance()
                        ? _c("b-tab", {
                            attrs: { disabled: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "title",
                                  fn: function() {
                                    return [
                                      _c("v-icon", {
                                        staticClass: "mr-2",
                                        attrs: {
                                          name: "buttons/payment",
                                          size: 13
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("Расходы")])
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              false,
                              3230516252
                            )
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.canLocationReadFinance()
                        ? _c("b-tab", {
                            attrs: { disabled: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "title",
                                  fn: function() {
                                    return [
                                      _c("v-icon", {
                                        staticClass: "mr-2",
                                        attrs: {
                                          name: "navbar/staffs",
                                          size: 13
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("Сотрудники")])
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              false,
                              2039988294
                            )
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("b-tab", {
                        attrs: { disabled: "" },
                        scopedSlots: _vm._u([
                          {
                            key: "title",
                            fn: function() {
                              return [
                                _c("v-icon", {
                                  staticClass: "mr-2",
                                  attrs: { name: "buttons/phone", size: 13 }
                                }),
                                _vm._v(" "),
                                _c("span", [_vm._v("Контакты")])
                              ]
                            },
                            proxy: true
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("b-tab", {
                        attrs: { disabled: "" },
                        scopedSlots: _vm._u([
                          {
                            key: "title",
                            fn: function() {
                              return [
                                _c("v-icon", {
                                  staticClass: "mr-2",
                                  attrs: { name: "navbar/reports", size: 13 }
                                }),
                                _vm._v(" "),
                                _c("span", [_vm._v("Документы")])
                              ]
                            },
                            proxy: true
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("b-tab", {
                        attrs: { disabled: "" },
                        scopedSlots: _vm._u([
                          {
                            key: "title",
                            fn: function() {
                              return [
                                _c("v-icon", {
                                  staticClass: "mr-2",
                                  attrs: { name: "buttons/file", size: 13 }
                                }),
                                _vm._v(" "),
                                _c("span", [_vm._v("Медиафайлы")])
                              ]
                            },
                            proxy: true
                          }
                        ])
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-card",
                    { staticClass: "custom-card mb-2" },
                    [
                      _c(
                        "b-row",
                        { staticClass: "mb-2 mt-2" },
                        [
                          _c(
                            "b-col",
                            [
                              _c("b-skeleton", {
                                staticClass: "mb-2",
                                attrs: { width: "5%", height: "24%" }
                              }),
                              _vm._v(" "),
                              _c("b-skeleton", {
                                attrs: {
                                  type: "input",
                                  width: "100%",
                                  height: "45%"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "mb-2" },
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "6" } },
                            [
                              _c("b-skeleton", {
                                staticClass: "mb-2",
                                attrs: { width: "12%", height: "24%" }
                              }),
                              _vm._v(" "),
                              _c("b-skeleton", {
                                attrs: {
                                  type: "input",
                                  width: "100%",
                                  height: "45%"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            {
                              staticClass: "d-flex align-items-center mt-2",
                              attrs: { cols: "3" }
                            },
                            [
                              _c("b-skeleton", {
                                attrs: {
                                  type: "input",
                                  width: "60%",
                                  height: "50%"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { cols: "3" } },
                            [
                              _c("b-skeleton", {
                                staticClass: "mb-2",
                                attrs: { width: "26%", height: "24%" }
                              }),
                              _vm._v(" "),
                              _c("b-skeleton", {
                                attrs: {
                                  type: "input",
                                  width: "100%",
                                  height: "45%"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "6" } },
                            [
                              _c("b-skeleton", {
                                staticClass: "mb-2",
                                attrs: { width: "7%", height: "17%" }
                              }),
                              _vm._v(" "),
                              _c("b-skeleton", {
                                staticClass: "mb-2",
                                attrs: {
                                  type: "input",
                                  width: "100%",
                                  height: "30%"
                                }
                              }),
                              _vm._v(" "),
                              _c("b-skeleton", {
                                attrs: { width: "20%", height: "14%" }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("b-skeleton", {
                                staticClass: "mb-2",
                                attrs: { width: "25%", height: "17%" }
                              }),
                              _vm._v(" "),
                              _c("b-skeleton", {
                                staticClass: "mb-2",
                                attrs: {
                                  type: "input",
                                  width: "100%",
                                  height: "30%"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("b-skeleton", {
                                staticClass: "mb-2",
                                attrs: { width: "63%", height: "17%" }
                              }),
                              _vm._v(" "),
                              _c("b-skeleton", {
                                staticClass: "mb-2",
                                attrs: {
                                  type: "input",
                                  width: "100%",
                                  height: "30%"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "mb-1" },
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "6" } },
                            [
                              _c("b-skeleton", {
                                staticClass: "mb-2",
                                attrs: { width: "14%", height: "24%" }
                              }),
                              _vm._v(" "),
                              _c("b-skeleton", {
                                attrs: {
                                  type: "input",
                                  width: "29%",
                                  height: "32%"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { cols: "3" } },
                            [
                              _c("b-skeleton", {
                                staticClass: "mb-2",
                                attrs: { width: "17%", height: "21%" }
                              }),
                              _vm._v(" "),
                              _c("b-skeleton", {
                                attrs: {
                                  type: "input",
                                  width: "100%",
                                  height: "44%"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { cols: "3" } },
                            [
                              _c("b-skeleton", {
                                staticClass: "mb-2",
                                attrs: { width: "27%", height: "21%" }
                              }),
                              _vm._v(" "),
                              _c("b-skeleton", {
                                attrs: {
                                  type: "input",
                                  width: "100%",
                                  height: "44%"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "mb-2" },
                        [
                          _c(
                            "b-col",
                            [
                              _c("b-skeleton", {
                                staticClass: "mb-2",
                                attrs: { width: "13%", height: "24%" }
                              }),
                              _vm._v(" "),
                              _c("b-skeleton", {
                                attrs: {
                                  type: "input",
                                  width: "32%",
                                  height: "45%"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "mb-2" },
                        [
                          _c(
                            "b-col",
                            [
                              _c("b-skeleton", {
                                staticClass: "mb-2",
                                attrs: { width: "12%", height: "24%" }
                              }),
                              _vm._v(" "),
                              _c("b-skeleton", {
                                attrs: {
                                  type: "input",
                                  width: "32%",
                                  height: "45%"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "mb-2" },
                        [
                          _c(
                            "b-col",
                            [
                              _c("b-skeleton", {
                                staticClass: "mb-2",
                                attrs: { width: "9%", height: "24%" }
                              }),
                              _vm._v(" "),
                              _c("b-skeleton", {
                                attrs: {
                                  type: "input",
                                  width: "32%",
                                  height: "45%"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "mb-2" },
                        [
                          _c(
                            "b-col",
                            [
                              _c("b-skeleton", {
                                staticClass: "mb-2",
                                attrs: { width: "11%", height: "24%" }
                              }),
                              _vm._v(" "),
                              _c("b-skeleton", {
                                attrs: {
                                  type: "input",
                                  width: "32%",
                                  height: "45%"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            [
                              _c("b-skeleton", {
                                staticClass: "mb-2",
                                attrs: { width: "7%", height: "24%" }
                              }),
                              _vm._v(" "),
                              _c("b-skeleton", {
                                attrs: {
                                  type: "input",
                                  width: "32%",
                                  height: "45%"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              },
              proxy: true
            },
            {
              key: "default",
              fn: function() {
                return [
                  _c(
                    "b-tabs",
                    { staticClass: "custom-tabs", attrs: { card: "" } },
                    [
                      _c(
                        "b-tab",
                        {
                          attrs: { active: "" },
                          scopedSlots: _vm._u([
                            {
                              key: "title",
                              fn: function() {
                                return [
                                  _c("v-icon", {
                                    staticClass: "mr-2",
                                    attrs: {
                                      name: "navbar/locations",
                                      size: 13
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("Основная")])
                                ]
                              },
                              proxy: true
                            }
                          ])
                        },
                        [
                          _vm._v(" "),
                          _c(
                            "b-card",
                            { staticClass: "custom-card mb-2" },
                            [
                              _c(
                                "h6",
                                { staticClass: "text-muted text-small" },
                                [_vm._v("ОСНОВНАЯ ИНФОРМАЦИЯ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { cols: "6" } },
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          staticClass: "mb-0",
                                          attrs: {
                                            id: "group-name",
                                            label: _vm.$t(
                                              "message.locations.modal.nameInput"
                                            )
                                          }
                                        },
                                        [
                                          _c("b-form-input", {
                                            attrs: {
                                              size: "sm",
                                              type: "text",
                                              disabled: _vm.isDisabled,
                                              placeholder: "Введите название",
                                              state: _vm.getFieldState("name")
                                            },
                                            model: {
                                              value: _vm.newItem.name,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.newItem,
                                                  "name",
                                                  $$v
                                                )
                                              },
                                              expression: "newItem.name"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    { attrs: { cols: "3" } },
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          staticClass: "mb-0",
                                          attrs: {
                                            id: "group-town",
                                            label: "Город"
                                          }
                                        },
                                        [
                                          _c("town-select", {
                                            attrs: {
                                              value: _vm.newItem.town_id,
                                              "is-disabled": _vm.isDisabled,
                                              state: _vm.getFieldState(
                                                "town_id"
                                              )
                                            },
                                            on: { onSelect: _vm.onSelectTown }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    { attrs: { cols: "3" } },
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          staticClass: "mb-0",
                                          attrs: {
                                            id: "group-status",
                                            label: "Статус объекта"
                                          }
                                        },
                                        [
                                          _c("location-status-select", {
                                            attrs: {
                                              value: _vm.newItem.status_id,
                                              "is-disabled": _vm.isDisabled
                                            },
                                            on: {
                                              onSelect:
                                                _vm.onSelectLocationStatus
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { cols: "6" } },
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          staticClass: "mb-0",
                                          attrs: {
                                            id: "group-organization",
                                            label: "Организация",
                                            description:
                                              "Будет отображаться при выставлении счёта"
                                          }
                                        },
                                        [
                                          _c("organization-select", {
                                            ref: "organization_select",
                                            attrs: {
                                              "is-disabled": _vm.isDisabled,
                                              value:
                                                _vm.newItem.organization_id,
                                              state: _vm.getFieldState(
                                                "organization_id"
                                              )
                                            },
                                            on: { onSelect: _vm.onSelectOrg }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          staticClass: "mb-0",
                                          attrs: {
                                            id: "group-customer",
                                            label: _vm.$t(
                                              "message.locations.modal.customerInput"
                                            )
                                          }
                                        },
                                        [
                                          _c("customer-select", {
                                            ref: "customer_select",
                                            attrs: {
                                              "is-disabled": _vm.isDisabled,
                                              state: _vm.getFieldState(
                                                "customer_id"
                                              ),
                                              value: _vm.newItem.customer_id,
                                              "selected-name":
                                                _vm.newItem.customer_name
                                            },
                                            on: {
                                              onSelect: _vm.onSelectCustomer
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-button",
                                {
                                  directives: [
                                    {
                                      name: "b-toggle",
                                      rawName:
                                        "v-b-toggle.collapse-customer-details",
                                      modifiers: {
                                        "collapse-customer-details": true
                                      }
                                    }
                                  ],
                                  staticStyle: {
                                    color: "#1A9167 !important",
                                    "text-decoration": "none !important"
                                  },
                                  attrs: { variant: "link" }
                                },
                                [
                                  _c("v-icon", {
                                    staticClass: "mr-1",
                                    attrs: {
                                      name: _vm.isCustomerOpen
                                        ? "buttons/collapse_chevrons_right"
                                        : "buttons/collapse_chevrons_down",
                                      size: 12
                                    }
                                  }),
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.isCustomerOpen
                                          ? "Скрыть реквизиты"
                                          : "Показать реквизиты"
                                      ) +
                                      "\n              "
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-collapse",
                                {
                                  attrs: { id: "collapse-customer-details" },
                                  model: {
                                    value: _vm.isCustomerOpen,
                                    callback: function($$v) {
                                      _vm.isCustomerOpen = $$v
                                    },
                                    expression: "isCustomerOpen"
                                  }
                                },
                                [
                                  _c(
                                    "b-card",
                                    { staticClass: "mb-2 custom-card" },
                                    [
                                      _c(
                                        "h6",
                                        {
                                          staticClass: "text-muted text-small"
                                        },
                                        [_vm._v("БАНКОВСКИЕ РЕКВИЗИТЫ")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-row",
                                        {
                                          staticClass: "align-items-end",
                                          attrs: { cols: "2" }
                                        },
                                        [
                                          _c(
                                            "b-col",
                                            [
                                              _c(
                                                "b-form-group",
                                                {
                                                  staticClass: "mb-0",
                                                  attrs: {
                                                    id: "group-bik",
                                                    label: _vm.$t(
                                                      "message.customers.modal.bik"
                                                    )
                                                  }
                                                },
                                                [
                                                  _c("b-form-input", {
                                                    attrs: {
                                                      size: "sm",
                                                      autocomplete: "off",
                                                      disabled: ""
                                                    },
                                                    model: {
                                                      value: _vm.customer.bik,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.customer,
                                                          "bik",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "customer.bik"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-form-group",
                                                {
                                                  staticClass: "mb-0",
                                                  attrs: {
                                                    id: "group-cor-account",
                                                    label: _vm.$t(
                                                      "message.customers.modal.cor_account"
                                                    )
                                                  }
                                                },
                                                [
                                                  _c("b-form-input", {
                                                    attrs: {
                                                      size: "sm",
                                                      autocomplete: "off",
                                                      disabled: ""
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.customer
                                                          .cor_account,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.customer,
                                                          "cor_account",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "customer.cor_account"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-col",
                                            [
                                              _c(
                                                "b-form-group",
                                                {
                                                  staticClass: "mb-0",
                                                  attrs: {
                                                    id: "group-bank",
                                                    label: _vm.$t(
                                                      "message.customers.modal.bank"
                                                    )
                                                  }
                                                },
                                                [
                                                  _c("b-form-input", {
                                                    attrs: {
                                                      size: "sm",
                                                      autocomplete: "off",
                                                      disabled: ""
                                                    },
                                                    model: {
                                                      value: _vm.customer.bank,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.customer,
                                                          "bank",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "customer.bank"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-form-group",
                                                {
                                                  staticClass: "mb-0",
                                                  attrs: {
                                                    id:
                                                      "group-checking-account",
                                                    label: _vm.$t(
                                                      "message.customers.modal.checking_account"
                                                    )
                                                  }
                                                },
                                                [
                                                  _c("b-form-input", {
                                                    attrs: {
                                                      size: "sm",
                                                      autocomplete: "off",
                                                      disabled: ""
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.customer
                                                          .checking_account,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.customer,
                                                          "checking_account",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "customer.checking_account"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-card",
                            { staticClass: "custom-card mb-2" },
                            [
                              _c(
                                "h6",
                                { staticClass: "text-muted text-small" },
                                [_vm._v("МАРКЕТИНГ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          attrs: {
                                            id: "group-marketing-source",
                                            label: "Источник"
                                          }
                                        },
                                        [
                                          _c("marketing-source-select", {
                                            attrs: {
                                              value:
                                                _vm.newItem.marketing_source_id,
                                              "is-disabled": _vm.isDisabled
                                            },
                                            on: {
                                              onSelect:
                                                _vm.onSelectMarketingSource
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          attrs: {
                                            id:
                                              "group-marketing-source-comment",
                                            label: "Источник комментарий"
                                          }
                                        },
                                        [
                                          _c("b-form-input", {
                                            attrs: {
                                              type: "text",
                                              size: "sm",
                                              disabled: _vm.isDisabled
                                            },
                                            model: {
                                              value:
                                                _vm.newItem
                                                  .marketing_source_comment,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.newItem,
                                                  "marketing_source_comment",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "newItem.marketing_source_comment"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-card",
                            { staticClass: "custom-card" },
                            [
                              _c(
                                "h6",
                                { staticClass: "text-muted text-small" },
                                [_vm._v("ФИНАНСОВЫЕ ПАРАМЕТРЫ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { cols: "6" } },
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          attrs: {
                                            id: "group-price",
                                            label: "Тип оплаты"
                                          }
                                        },
                                        [
                                          _c("b-form-radio-group", {
                                            attrs: {
                                              size: "sm",
                                              disabled: _vm.isDisabled,
                                              options: _vm.paymentOptions
                                            },
                                            model: {
                                              value: _vm.newItem.payment_type,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.newItem,
                                                  "payment_type",
                                                  $$v
                                                )
                                              },
                                              expression: "newItem.payment_type"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    { attrs: { cols: "3" } },
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          attrs: {
                                            id: "group-category",
                                            label: "Категория"
                                          }
                                        },
                                        [
                                          _c("b-form-input", {
                                            attrs: {
                                              size: "sm",
                                              placeholder:
                                                "Введите категорию для БалансПРО",
                                              disabled: _vm.isDisabled
                                            },
                                            model: {
                                              value: _vm.newItem.category_name,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.newItem,
                                                  "category_name",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "newItem.category_name"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.canLocationReadFinance()
                                ? _c(
                                    "b-row",
                                    [
                                      _c(
                                        "b-col",
                                        { attrs: { lg: "3" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-management-cost",
                                                label: "Управленческие расходы"
                                              }
                                            },
                                            [
                                              _c(
                                                "b-input-group",
                                                {
                                                  attrs: { size: "sm" },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "append",
                                                        fn: function() {
                                                          return [
                                                            _c(
                                                              "b-input-group-text",
                                                              {
                                                                attrs: {
                                                                  size: "sm"
                                                                }
                                                              },
                                                              [_vm._v("%")]
                                                            )
                                                          ]
                                                        },
                                                        proxy: true
                                                      }
                                                    ],
                                                    null,
                                                    false,
                                                    681183213
                                                  )
                                                },
                                                [
                                                  _c("b-form-input", {
                                                    attrs: {
                                                      size: "sm",
                                                      type: "number",
                                                      min: "0",
                                                      disabled:
                                                        _vm.isDisabled ||
                                                        !_vm.canLocationEditFinance(),
                                                      placeholder: "0"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.newItem
                                                          .management_cost,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.newItem,
                                                          "management_cost",
                                                          _vm._n($$v)
                                                        )
                                                      },
                                                      expression:
                                                        "newItem.management_cost"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        { attrs: { lg: "3" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-smz-cost",
                                                label: "Комиссия сервиса СМЗ"
                                              }
                                            },
                                            [
                                              _c(
                                                "b-input-group",
                                                {
                                                  attrs: { size: "sm" },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "append",
                                                        fn: function() {
                                                          return [
                                                            _c(
                                                              "b-input-group-text",
                                                              {
                                                                attrs: {
                                                                  size: "sm"
                                                                }
                                                              },
                                                              [_vm._v("%")]
                                                            )
                                                          ]
                                                        },
                                                        proxy: true
                                                      }
                                                    ],
                                                    null,
                                                    false,
                                                    681183213
                                                  )
                                                },
                                                [
                                                  _c("b-form-input", {
                                                    attrs: {
                                                      size: "sm",
                                                      type: "number",
                                                      min: "0",
                                                      disabled:
                                                        _vm.isDisabled ||
                                                        !_vm.canLocationEditFinance(),
                                                      placeholder: "0"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.newItem.smz_cost,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.newItem,
                                                          "smz_cost",
                                                          _vm._n($$v)
                                                        )
                                                      },
                                                      expression:
                                                        "newItem.smz_cost"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        { attrs: { lg: "3" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-profit-tax",
                                                label: "Налог на прибыль"
                                              }
                                            },
                                            [
                                              _c(
                                                "b-input-group",
                                                {
                                                  attrs: { size: "sm" },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "append",
                                                        fn: function() {
                                                          return [
                                                            _c(
                                                              "b-input-group-text",
                                                              {
                                                                attrs: {
                                                                  size: "sm"
                                                                }
                                                              },
                                                              [_vm._v("%")]
                                                            )
                                                          ]
                                                        },
                                                        proxy: true
                                                      }
                                                    ],
                                                    null,
                                                    false,
                                                    681183213
                                                  )
                                                },
                                                [
                                                  _c("b-form-input", {
                                                    attrs: {
                                                      size: "sm",
                                                      type: "number",
                                                      min: "0",
                                                      disabled:
                                                        _vm.isDisabled ||
                                                        !_vm.canLocationEditFinance(),
                                                      placeholder: "0"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.newItem.profit_tax,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.newItem,
                                                          "profit_tax",
                                                          _vm._n($$v)
                                                        )
                                                      },
                                                      expression:
                                                        "newItem.profit_tax"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        { attrs: { lg: "3" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-transfer-commission",
                                                label: "Комиссия за трансфер"
                                              }
                                            },
                                            [
                                              _c(
                                                "b-input-group",
                                                {
                                                  attrs: { size: "sm" },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "append",
                                                        fn: function() {
                                                          return [
                                                            _c(
                                                              "b-input-group-text",
                                                              {
                                                                attrs: {
                                                                  size: "sm"
                                                                }
                                                              },
                                                              [_vm._v("%")]
                                                            )
                                                          ]
                                                        },
                                                        proxy: true
                                                      }
                                                    ],
                                                    null,
                                                    false,
                                                    681183213
                                                  )
                                                },
                                                [
                                                  _c("b-form-input", {
                                                    attrs: {
                                                      size: "sm",
                                                      type: "number",
                                                      min: "0",
                                                      disabled:
                                                        _vm.isDisabled ||
                                                        !_vm.canLocationEditFinance(),
                                                      placeholder: "0"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.newItem
                                                          .transfer_commission,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.newItem,
                                                          "transfer_commission",
                                                          _vm._n($$v)
                                                        )
                                                      },
                                                      expression:
                                                        "newItem.transfer_commission"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _vm.canLocationReadFinance() &&
                                      (_vm.newItem.payment_type === 1 ||
                                        _vm.newItem.payment_type === 2)
                                        ? _c(
                                            "b-col",
                                            { attrs: { lg: "3" } },
                                            [
                                              _c(
                                                "b-form-group",
                                                {
                                                  attrs: {
                                                    id: "group-nds",
                                                    label: "НДС"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "b-input-group",
                                                    {
                                                      attrs: { size: "sm" },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "append",
                                                            fn: function() {
                                                              return [
                                                                _c(
                                                                  "b-input-group-text",
                                                                  {
                                                                    attrs: {
                                                                      size: "sm"
                                                                    }
                                                                  },
                                                                  [_vm._v("%")]
                                                                )
                                                              ]
                                                            },
                                                            proxy: true
                                                          }
                                                        ],
                                                        null,
                                                        false,
                                                        681183213
                                                      )
                                                    },
                                                    [
                                                      _c("b-form-input", {
                                                        attrs: {
                                                          size: "sm",
                                                          type: "number",
                                                          min: "0",
                                                          disabled:
                                                            _vm.isDisabled ||
                                                            !_vm.canLocationEditFinance(),
                                                          placeholder: "0"
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.newItem.nds,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.newItem,
                                                              "nds",
                                                              _vm._n($$v)
                                                            )
                                                          },
                                                          expression:
                                                            "newItem.nds"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.canLocationReadFinance() &&
                              _vm.newItem.payment_type === 2
                                ? _c(
                                    "b-row",
                                    [
                                      _c(
                                        "b-col",
                                        { attrs: { lg: "4" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-bank-commission",
                                                label:
                                                  "Банковская коммисия для ИП"
                                              }
                                            },
                                            [
                                              _c(
                                                "b-input-group",
                                                {
                                                  attrs: { size: "sm" },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "append",
                                                        fn: function() {
                                                          return [
                                                            _c(
                                                              "b-input-group-text",
                                                              {
                                                                attrs: {
                                                                  size: "sm"
                                                                }
                                                              },
                                                              [_vm._v("%")]
                                                            )
                                                          ]
                                                        },
                                                        proxy: true
                                                      }
                                                    ],
                                                    null,
                                                    false,
                                                    681183213
                                                  )
                                                },
                                                [
                                                  _c("b-form-input", {
                                                    attrs: {
                                                      size: "sm",
                                                      type: "number",
                                                      min: "0",
                                                      disabled:
                                                        _vm.isDisabled ||
                                                        !_vm.canLocationEditFinance(),
                                                      placeholder: "0"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.newItem
                                                          .bank_commission,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.newItem,
                                                          "bank_commission",
                                                          _vm._n($$v)
                                                        )
                                                      },
                                                      expression:
                                                        "newItem.bank_commission"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.canLocationReadFinance() &&
                              _vm.newItem.payment_type === 2
                                ? _c(
                                    "b-row",
                                    [
                                      _c(
                                        "b-col",
                                        { attrs: { lg: "4" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-ip-commission",
                                                label: "Комиссия на вывод ИП"
                                              }
                                            },
                                            [
                                              _c(
                                                "b-input-group",
                                                {
                                                  attrs: { size: "sm" },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "append",
                                                        fn: function() {
                                                          return [
                                                            _c(
                                                              "b-input-group-text",
                                                              {
                                                                attrs: {
                                                                  size: "sm"
                                                                }
                                                              },
                                                              [_vm._v("%")]
                                                            )
                                                          ]
                                                        },
                                                        proxy: true
                                                      }
                                                    ],
                                                    null,
                                                    false,
                                                    681183213
                                                  )
                                                },
                                                [
                                                  _c("b-form-input", {
                                                    attrs: {
                                                      size: "sm",
                                                      type: "number",
                                                      min: "0",
                                                      disabled:
                                                        _vm.isDisabled ||
                                                        !_vm.canLocationEditFinance(),
                                                      placeholder: "0"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.newItem
                                                          .ip_commission,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.newItem,
                                                          "ip_commission",
                                                          _vm._n($$v)
                                                        )
                                                      },
                                                      expression:
                                                        "newItem.ip_commission"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-tab",
                        {
                          scopedSlots: _vm._u([
                            {
                              key: "title",
                              fn: function() {
                                return [
                                  _c("v-icon", {
                                    staticClass: "mr-2",
                                    attrs: {
                                      name: "buttons/page_list",
                                      size: 13
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("Детали")])
                                ]
                              },
                              proxy: true
                            }
                          ])
                        },
                        [
                          _vm._v(" "),
                          _c(
                            "b-card",
                            { staticClass: "custom-card" },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "group-address",
                                    label: _vm.$t(
                                      "message.locations.modal.addressInput"
                                    )
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      type: "text",
                                      disabled: _vm.isDisabled
                                    },
                                    model: {
                                      value: _vm.newItem.address,
                                      callback: function($$v) {
                                        _vm.$set(_vm.newItem, "address", $$v)
                                      },
                                      expression: "newItem.address"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { cols: "4" } },
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          attrs: {
                                            id: "group-contract",
                                            label: _vm.$t(
                                              "message.locations.modal.contractInput"
                                            )
                                          }
                                        },
                                        [
                                          _c("b-form-input", {
                                            attrs: {
                                              type: "text",
                                              disabled: _vm.isDisabled
                                            },
                                            model: {
                                              value: _vm.newItem.contract,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.newItem,
                                                  "contract",
                                                  $$v
                                                )
                                              },
                                              expression: "newItem.contract"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          attrs: {
                                            id: "group-contact",
                                            label: _vm.$t(
                                              "message.locations.modal.contactInput"
                                            )
                                          }
                                        },
                                        [
                                          _c("b-form-input", {
                                            attrs: {
                                              type: "text",
                                              disabled: _vm.isDisabled
                                            },
                                            model: {
                                              value: _vm.newItem.contact,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.newItem,
                                                  "contact",
                                                  $$v
                                                )
                                              },
                                              expression: "newItem.contact"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "group-description",
                                    label: "Описание"
                                  }
                                },
                                [
                                  _c("b-form-textarea", {
                                    staticClass: "text-small",
                                    attrs: {
                                      disabled: _vm.isDisabled,
                                      placeholder:
                                        "Заполните необходимую информацию об объекте",
                                      rows: 5,
                                      "max-rows": 20,
                                      "no-resize": ""
                                    },
                                    model: {
                                      value: _vm.newItem.description,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.newItem,
                                          "description",
                                          $$v
                                        )
                                      },
                                      expression: "newItem.description"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  staticStyle: { "overflow-anchor": "none" },
                                  attrs: {
                                    id: "group-posting-order",
                                    label: "Порядок выхода"
                                  }
                                },
                                [
                                  _c("b-form-textarea", {
                                    staticClass: "text-small",
                                    attrs: {
                                      disabled: _vm.isDisabled,
                                      placeholder:
                                        "Заполните необходимую информацию о порядке выхода на объект",
                                      rows: 5,
                                      "max-rows": 20,
                                      "no-resize": ""
                                    },
                                    model: {
                                      value: _vm.newItem.posting_order,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.newItem,
                                          "posting_order",
                                          $$v
                                        )
                                      },
                                      expression: "newItem.posting_order"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  staticStyle: { "overflow-anchor": "none" },
                                  attrs: {
                                    id: "group-interview-script",
                                    label: "Скрипт интервью"
                                  }
                                },
                                [
                                  _c("b-form-textarea", {
                                    staticClass: "text-small",
                                    attrs: {
                                      disabled: _vm.isDisabled,
                                      placeholder:
                                        "Критически важные вопросы для кандидатов перед их одобрением",
                                      rows: 5,
                                      "max-rows": 20,
                                      "no-resize": ""
                                    },
                                    model: {
                                      value: _vm.newItem.interview_script,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.newItem,
                                          "interview_script",
                                          $$v
                                        )
                                      },
                                      expression: "newItem.interview_script"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  staticStyle: { "overflow-anchor": "none" },
                                  attrs: {
                                    id: "group-employment-documents",
                                    label: "Документы для трудоустройства"
                                  }
                                },
                                [
                                  _c("b-form-textarea", {
                                    staticClass: "text-small",
                                    attrs: {
                                      disabled: _vm.isDisabled,
                                      placeholder:
                                        "Введите требуемые документы для трудоустройства граждан СНГ и ЕАЭС",
                                      rows: 5,
                                      "max-rows": 20,
                                      "no-resize": ""
                                    },
                                    model: {
                                      value: _vm.newItem.employment_documents,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.newItem,
                                          "employment_documents",
                                          $$v
                                        )
                                      },
                                      expression: "newItem.employment_documents"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-tab",
                        {
                          scopedSlots: _vm._u([
                            {
                              key: "title",
                              fn: function() {
                                return [
                                  _c("v-icon", {
                                    staticClass: "mr-2",
                                    attrs: {
                                      name: "buttons/user_group_add",
                                      size: 13
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("Вакансии")])
                                ]
                              },
                              proxy: true
                            }
                          ])
                        },
                        [
                          _vm._v(" "),
                          _c("location-vacancies", {
                            ref: "location_vacancies",
                            attrs: { "is-disabled": _vm.isDisabled }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-tab",
                        {
                          scopedSlots: _vm._u([
                            {
                              key: "title",
                              fn: function() {
                                return [
                                  _c("v-icon", {
                                    staticClass: "mr-2",
                                    attrs: {
                                      name: "navbar/recruit_tasks",
                                      size: 13
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("Подбор")])
                                ]
                              },
                              proxy: true
                            }
                          ])
                        },
                        [
                          _vm._v(" "),
                          _vm.newItem.id
                            ? _c("recruit-tasks", {
                                attrs: {
                                  "location-id": _vm.newItem.id,
                                  "location-name": _vm.newItem.name,
                                  "disabled-routing": true,
                                  "is-integrated": true
                                },
                                on: { refresh: _vm.onRecruitTasksRefresh }
                              })
                            : _c(
                                "b-alert",
                                {
                                  staticClass: "pb-3 mb-0",
                                  attrs: { show: "", variant: "danger" }
                                },
                                [
                                  _vm._v(
                                    "\n              Сохраните карточку объекта, чтобы просматривать заявки на подбор.\n            "
                                  )
                                ]
                              )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-tab",
                        {
                          attrs: { active: _vm.servicesTabActive },
                          on: {
                            "update:active": function($event) {
                              _vm.servicesTabActive = $event
                            }
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "title",
                              fn: function() {
                                return [
                                  _c("v-icon", {
                                    staticClass: "mr-2",
                                    attrs: {
                                      name: "buttons/card_container",
                                      size: 13
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("Услуги исполнителей")])
                                ]
                              },
                              proxy: true
                            }
                          ])
                        },
                        [
                          _vm._v(" "),
                          _c("location-work-services", {
                            ref: "location_work_services",
                            attrs: { "is-disabled": _vm.isDisabled }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-tab",
                        {
                          scopedSlots: _vm._u([
                            {
                              key: "title",
                              fn: function() {
                                return [
                                  _c("v-icon", {
                                    staticClass: "mr-2",
                                    attrs: { name: "buttons/work", size: 13 }
                                  }),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("Работы")])
                                ]
                              },
                              proxy: true
                            }
                          ])
                        },
                        [
                          _vm._v(" "),
                          _c("location-works", {
                            ref: "location_works",
                            attrs: { "is-disabled": _vm.isDisabled }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.canLocationReadFinance()
                        ? _c(
                            "b-tab",
                            {
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "title",
                                    fn: function() {
                                      return [
                                        _c("v-icon", {
                                          staticClass: "mr-2",
                                          attrs: {
                                            name: "buttons/payment",
                                            size: 13
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("span", [_vm._v("Расходы")])
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                false,
                                3230516252
                              )
                            },
                            [
                              _vm._v(" "),
                              _c("location-costs", {
                                ref: "location_costs",
                                attrs: { "is-disabled": _vm.isDisabled }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.canLocationReadFinance()
                        ? _c(
                            "b-tab",
                            {
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "title",
                                    fn: function() {
                                      return [
                                        _c("v-icon", {
                                          staticClass: "mr-2",
                                          attrs: {
                                            name: "navbar/staffs",
                                            size: 13
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("span", [_vm._v("Сотрудники")])
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                false,
                                2039988294
                              )
                            },
                            [
                              _vm._v(" "),
                              _vm.canLocationReadFinance()
                                ? _c(
                                    "b-row",
                                    [
                                      _c(
                                        "b-col",
                                        { attrs: { cols: "4" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              staticClass: "mb-4",
                                              attrs: {
                                                id: "group_rate",
                                                label:
                                                  "Тип ставки для сотрудников"
                                              }
                                            },
                                            [
                                              _c("b-form-radio-group", {
                                                attrs: {
                                                  size: "sm",
                                                  disabled:
                                                    _vm.isDisabled ||
                                                    !_vm.canLocationEditFinance(),
                                                  options: _vm.rateOptions
                                                },
                                                model: {
                                                  value: _vm.newItem.rate_type,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "rate_type",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "newItem.rate_type"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "b-card",
                                { staticClass: "custom-card mb-2" },
                                [
                                  _c(
                                    "h6",
                                    { staticClass: "text-muted text-small" },
                                    [_vm._v("РУКОВОДИТЕЛЬ")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "d-flex align-items-center"
                                    },
                                    [
                                      _c("user-select", {
                                        ref: "project_select",
                                        attrs: {
                                          "is-disabled":
                                            _vm.isDisabled ||
                                            !_vm.canLocationEditFinance()
                                        },
                                        on: { onSelect: _vm.onSelectProject }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "b-button",
                                        {
                                          staticClass:
                                            "custom-btn-primary ml-2",
                                          attrs: {
                                            disabled:
                                              _vm.isDisabled ||
                                              !_vm.selectedProjectId ||
                                              !_vm.canLocationEditFinance()
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.onAddProject(
                                                _vm.selectedProjectId
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  Добавить\n                "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("b-table", {
                                    ref: "projects",
                                    staticClass: "mb-0 text-small",
                                    attrs: {
                                      id: "location-projects",
                                      "thead-class": "d-none",
                                      busy: _vm.isBusy,
                                      items: _vm.projects,
                                      fields: _vm.fields,
                                      "current-page": _vm.currentPage,
                                      "per-page": _vm.perPage
                                    },
                                    on: {
                                      "update:busy": function($event) {
                                        _vm.isBusy = $event
                                      }
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "table-busy",
                                          fn: function() {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "text-center text-success my-2"
                                                },
                                                [
                                                  _c("b-spinner", {
                                                    staticClass: "align-middle"
                                                  }),
                                                  _vm._v(" "),
                                                  _c("strong", [
                                                    _vm._v("Загрузка")
                                                  ])
                                                ],
                                                1
                                              )
                                            ]
                                          },
                                          proxy: true
                                        },
                                        {
                                          key: "cell(name)",
                                          fn: function(row) {
                                            return [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(row.item.name) +
                                                  "\n                  "
                                              ),
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "text-secondary m-0"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        row.item.role_name
                                                      ) +
                                                      "\n                  "
                                                  )
                                                ]
                                              )
                                            ]
                                          }
                                        },
                                        {
                                          key: "cell(rate)",
                                          fn: function(row) {
                                            return [
                                              _c(
                                                "b-input-group",
                                                {
                                                  attrs: {
                                                    size: "sm",
                                                    prepend: "Ставка"
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "append",
                                                        fn: function() {
                                                          return [
                                                            _c(
                                                              "b-input-group-text",
                                                              {
                                                                attrs: {
                                                                  size: "sm"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.getRateSymbol()
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        },
                                                        proxy: true
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  )
                                                },
                                                [
                                                  _c("b-form-input", {
                                                    attrs: {
                                                      id: "input-rate",
                                                      type: "number",
                                                      disabled:
                                                        _vm.isDisabled ||
                                                        !_vm.canLocationEditFinance(),
                                                      size: "sm",
                                                      autocomplete: "off"
                                                    },
                                                    model: {
                                                      value: row.item.rate,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          row.item,
                                                          "rate",
                                                          _vm._n($$v)
                                                        )
                                                      },
                                                      expression:
                                                        "row.item.rate"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ]
                                          }
                                        },
                                        {
                                          key: "cell(action)",
                                          fn: function(row) {
                                            return [
                                              _c(
                                                "b-button",
                                                {
                                                  attrs: {
                                                    variant: "link",
                                                    disabled:
                                                      _vm.isDisabled ||
                                                      !_vm.canLocationEditFinance()
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.onRemoveProject(
                                                        row.item
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("v-icon", {
                                                    attrs: {
                                                      name: "buttons/trash",
                                                      size: 16
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      4076726673
                                    )
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-card",
                                { staticClass: "custom-card" },
                                [
                                  _c(
                                    "h6",
                                    { staticClass: "text-muted text-small" },
                                    [_vm._v("СОТРУДНИКИ")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "d-flex align-items-center"
                                    },
                                    [
                                      _c("user-select", {
                                        ref: "user_select",
                                        attrs: {
                                          "is-disabled":
                                            _vm.isDisabled ||
                                            !_vm.canLocationEditFinance()
                                        },
                                        on: { onSelect: _vm.onSelectUser }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "b-button",
                                        {
                                          staticClass:
                                            "custom-btn-primary ml-2",
                                          attrs: {
                                            disabled:
                                              _vm.isDisabled ||
                                              !_vm.selectedUserId ||
                                              !_vm.canLocationEditFinance()
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.onAddUser(
                                                _vm.selectedUserId
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  Добавить\n                "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("b-table", {
                                    ref: "users",
                                    staticClass: "mb-0 text-small",
                                    attrs: {
                                      id: "location-users",
                                      "thead-class": "d-none",
                                      busy: _vm.isBusy,
                                      items: _vm.users,
                                      fields: _vm.fields,
                                      "current-page": _vm.currentPage,
                                      "per-page": _vm.perPage
                                    },
                                    on: {
                                      "update:busy": function($event) {
                                        _vm.isBusy = $event
                                      }
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "table-busy",
                                          fn: function() {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "text-center text-success my-2"
                                                },
                                                [
                                                  _c("b-spinner", {
                                                    staticClass: "align-middle"
                                                  }),
                                                  _vm._v(" "),
                                                  _c("strong", [
                                                    _vm._v("Загрузка")
                                                  ])
                                                ],
                                                1
                                              )
                                            ]
                                          },
                                          proxy: true
                                        },
                                        {
                                          key: "cell(name)",
                                          fn: function(row) {
                                            return [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(row.item.name) +
                                                  "\n                  "
                                              ),
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "text-secondary m-0"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        row.item.role_name
                                                      ) +
                                                      "\n                  "
                                                  )
                                                ]
                                              )
                                            ]
                                          }
                                        },
                                        {
                                          key: "cell(rate)",
                                          fn: function(row) {
                                            return [
                                              _c(
                                                "b-input-group",
                                                {
                                                  attrs: {
                                                    size: "sm",
                                                    prepend: "Ставка"
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "append",
                                                        fn: function() {
                                                          return [
                                                            _c(
                                                              "b-input-group-text",
                                                              {
                                                                attrs: {
                                                                  size: "sm"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.getRateSymbol()
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        },
                                                        proxy: true
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  )
                                                },
                                                [
                                                  _c("b-form-input", {
                                                    attrs: {
                                                      id: "input-rate",
                                                      type: "number",
                                                      disabled:
                                                        _vm.isDisabled ||
                                                        !_vm.canLocationEditFinance(),
                                                      size: "sm",
                                                      autocomplete: "off"
                                                    },
                                                    model: {
                                                      value: row.item.rate,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          row.item,
                                                          "rate",
                                                          _vm._n($$v)
                                                        )
                                                      },
                                                      expression:
                                                        "row.item.rate"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ]
                                          }
                                        },
                                        {
                                          key: "cell(action)",
                                          fn: function(row) {
                                            return [
                                              _c(
                                                "b-button",
                                                {
                                                  attrs: {
                                                    variant: "link",
                                                    disabled:
                                                      _vm.isDisabled ||
                                                      !_vm.canLocationEditFinance()
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.onRemoveUser(
                                                        row.item
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("v-icon", {
                                                    attrs: {
                                                      name: "buttons/trash",
                                                      size: 16
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      3193759445
                                    )
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-tab",
                        {
                          scopedSlots: _vm._u([
                            {
                              key: "title",
                              fn: function() {
                                return [
                                  _c("v-icon", {
                                    staticClass: "mr-2",
                                    attrs: { name: "buttons/phone", size: 13 }
                                  }),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("Контакты")])
                                ]
                              },
                              proxy: true
                            }
                          ])
                        },
                        [
                          _vm._v(" "),
                          _c("location-contacts", {
                            ref: "location_contacts",
                            attrs: { "is-disabled": _vm.isDisabled }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-tab",
                        {
                          scopedSlots: _vm._u([
                            {
                              key: "title",
                              fn: function() {
                                return [
                                  _c("v-icon", {
                                    staticClass: "mr-2",
                                    attrs: { name: "navbar/reports", size: 13 }
                                  }),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("Документы")])
                                ]
                              },
                              proxy: true
                            }
                          ])
                        },
                        [
                          _vm._v(" "),
                          _c("location-files", {
                            ref: "location_files",
                            attrs: { "is-disabled": _vm.isDisabled }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-tab",
                        {
                          scopedSlots: _vm._u([
                            {
                              key: "title",
                              fn: function() {
                                return [
                                  _c("v-icon", {
                                    staticClass: "mr-2",
                                    attrs: { name: "buttons/file", size: 13 }
                                  }),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("Медиафайлы")])
                                ]
                              },
                              proxy: true
                            }
                          ])
                        },
                        [
                          _vm._v(" "),
                          _c("location-passport", {
                            ref: "location_passport_files",
                            attrs: { "is-disabled": _vm.isDisabled }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              },
              proxy: true
            }
          ])
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-48b152d4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48b152d4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Locations/Location.vue
// module id = null
// module chunks = 